export default function (type) {
    const types = {
        create: 'grey',
        approve: 'green',
        sign: 'green',
        upload_attachment: 'grey',
        decline: 'red',
        delete_attachment: 'red',
        rework: 'orange',
        edit: 'grey',
        delete: 'red',
        [null]: 'grey',
        [undefined]: 'grey',
        draft: 'grey',
        pending: 'grey',
        approving: 'grey',
        approved: 'green',
        signing: 'grey',
        signed: 'green',
        declined: 'red',
        preparing: 'grey',
        need_payment: 'red',
        paid: 'green',
        accrued: 'orange',
        completed: 'green',
        failed: 'red',
        canceled: 'red',
        done: 'green',
        in_progress: 'grey',
        error: 'red',
        partially_error: 'red',
    };
    return types[type];
}
